function localizedQuestionName(node, locale = 'ko') {
    if (!node || typeof node !== 'object') return '';
    const localizedKey = locale === 'en'
        ? 'question_name_e'
        : locale === 'ca'
            ? 'question_name_c'
            : 'question_name';
    return node[localizedKey] || node.question_name || '';
}

function flattenQuestionRail(templateContents, activeQuestionCode, locale = 'ko') {
    const rows = [];

    function visit(nodes, depth, path) {
        (Array.isArray(nodes) ? nodes : []).forEach((node, index) => {
            const questionCode = node && node.question_code ? String(node.question_code) : null;
            const hasChildren = Array.isArray(node && node.children) && node.children.length > 0;
            const isNavigableLeaf = depth > 0 && !hasChildren && Boolean(questionCode);
            const type = isNavigableLeaf ? 'question' : 'group';
            const pathKey = [...path, node && (node.id || node.question_code) || index].join('-');
            if (depth === 0 || !hasChildren) {
                rows.push({
                    key: `${type}-${pathKey}`,
                    type,
                    depth,
                    label: localizedQuestionName(node, locale),
                    questionCode,
                    active: type === 'question' && questionCode === String(activeQuestionCode || ''),
                    source: node,
                });
            }
            visit(node && node.children, depth + 1, [...path, index]);
        });
    }

    visit(templateContents, 0, []);
    return rows;
}

function findQuestionBreadcrumb(templateContents, questionCode, locale = 'ko') {
    const targetCode = String(questionCode || '');

    function find(nodes, ancestors) {
        for (const node of Array.isArray(nodes) ? nodes : []) {
            const path = [...ancestors, node];
            if (String(node && node.question_code || '') === targetCode) return path;
            const nested = find(node && node.children, path);
            if (nested) return nested;
        }
        return null;
    }

    const path = find(templateContents, []);
    if (!path) return {groupName: '', sectionName: '', questionName: ''};
    const groupNodes = path.slice(0, -1);
    return {
        groupName: localizedQuestionName(groupNodes[0], locale),
        sectionName: localizedQuestionName(groupNodes[groupNodes.length - 1], locale),
        questionName: localizedQuestionName(path[path.length - 1], locale),
    };
}

module.exports = {
    localizedQuestionName,
    flattenQuestionRail,
    findQuestionBreadcrumb,
};
